import mutations from "./mutations";
import * as actions from "./actions";

let state = { clocklog: null };

export default { mutations, actions, state }